import { IEvent } from "./event";
import { IOption } from "./option";
import { IText } from "./text";
import { IText_AddEditEvent } from "./text_AddEditEvent";

import { getDayOfMonth, getHours, getMinutes, getMonthNumber } from "../../calendar/reducers/changeTimePeriod";

export interface ICalendarSettingsFromService {
  filterOptions: IOption[];
  categoryOptions: IOption[];
  calendarName: string;
  hasCreatePermission: boolean;
  hasDeletePermission: boolean;
  hasEditPermission: boolean;
  isTwoWayCalendar: boolean;
  text: IText;
  userDateFormat: string;
  useModernAddAndEditEventScreen: boolean;
}

export interface ICalendarSettingsFromService_AddEditEvent {
  addEditText: IText_AddEditEvent;
  currentDateOnServer: string;
}

export interface ICalendarSettings {
  filterOptions: IOption[];
  calendarName: string;
  categoryOptions: IOption[];
  hasCreatePermission: boolean;
  hasDeletePermission: boolean;
  hasEditPermission: boolean;
  isTwoWayCalendar: boolean;
  text: object;
  viewModeOptions: IOption[];
  userDateFormat: string;
  useModernAddAndEditEventScreen: boolean;
}

export interface IOptionsResponse {
  error: string;
  options: IOption[];
}

export interface IEventsResponse {
  error: string;
  events: IEventResponse[];
}

export interface IEventResponse extends IEvent {
  error: string;
};

export interface IDateStruct {
  year: number;
  month: number;
  day: number;
  hour: number;
  minute: number;
}

export const convertDateToDateStruct = (theDate: Date): IDateStruct => {
  const year = theDate.getFullYear();
  const month = getMonthNumber(theDate) + 1;
  const day = getDayOfMonth(theDate);
  const hour = getHours(theDate);
  const minute = getMinutes(theDate);

  const theDateStruct: IDateStruct = { day, hour, minute, month, year };

  return theDateStruct;
};

export const convertDateStructToDate = (theDate: IDateStruct): Date => {
  return new Date(theDate.year, theDate.month - 1, theDate.day, 0, 0, 0);
};

export const convertDateStructToDateWithTime = (theDate: IDateStruct): Date => {
  return new Date(theDate.year, theDate.month - 1, theDate.day, theDate.hour, theDate.minute, 0);
};
